import {Injectable} from '@angular/core';
import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {PhrCategory} from '../models/phr-category.model';

@Injectable()
export class PhrCategoriesAdapter implements IAdapter<PhrCategory> {
  adaptToModel(resp: any): PhrCategory {
    const phrCategory: PhrCategory = new PhrCategory();
    if (resp) {
      phrCategory.id = resp.id;
      phrCategory.name = resp.name;
      phrCategory.description = resp.description;
    }
    return phrCategory;
  }
  adaptFromModel(data: PhrCategory): any {
    return data;
  }
}
